// extracted by mini-css-extract-plugin
export default {"block":"contact-us-page_block__Q5C8-"};